
export const prototypeName = 'Servicebund.RodeoSteakDe:Component.LinkedIcon';